export default __webpack_public_path__ + "static/media/rupee-charge.4dfa95d4.svg";